import React, { Fragment, useEffect } from 'react'

import CardView from 'components/Common/CardView'

import ActiveClientCard from 'components/Clients/ActiveClientCard'
import {
  TopActiveClientsWrapper,
  TopActiveClientsDesktopWrapper,
  TopActiveClientsMobileWrapper,
  NoClientWrapper,
} from 'components/Clients/style'

export default function TopActiveClients({ topActiveClients, getTopActiveClientsAction }) {
  useEffect(() => {
    getTopActiveClientsAction()
  }, [getTopActiveClientsAction])

  // Show loading state while data is being fetched (topActiveClients is null or undefined)
  const isLoading = topActiveClients === null || topActiveClients === undefined

  // Don't render anything until data is loaded
  if (isLoading) {
    return null
  }

  return (
    <>
      <TopActiveClientsWrapper>
        {topActiveClients.length > 0 ? (
          // Show actual client cards
          topActiveClients.map((client, index) => (
            <Fragment key={index}>
              <TopActiveClientsDesktopWrapper>
                <CardView
                  padding=""
                  margin=""
                  classes="rounded-lg bg-white shadow-md border border-secondary-text hover:shadow-lg transition-shadow"
                >
                  <ActiveClientCard client={client} index={index} />
                </CardView>
              </TopActiveClientsDesktopWrapper>
              <TopActiveClientsMobileWrapper>
                <CardView
                  padding=""
                  margin="mb-4"
                  classes="rounded-lg bg-white shadow-md border border-secondary-text"
                >
                  <ActiveClientCard isMobile={true} client={client} index={index} />
                </CardView>
              </TopActiveClientsMobileWrapper>
            </Fragment>
          ))
        ) : (
          // Show empty state when there are no clients
          <NoClientWrapper>You have no active clients.</NoClientWrapper>
        )}
      </TopActiveClientsWrapper>
    </>
  )
}
